import type { handlebarFilters, handlebarType } from '@/types/handlebar'
import { BikeHoodsType } from '@/types/bike'
import axios from 'axios'

export default class {
  static async fetchHandlebars({
    sessionId = undefined,
    filters = undefined,
  }: {
    sessionId?: string
    filters?: handlebarFilters
  } = {}) {
    return axios.post<handlebarType>('Hardware/RetrieveHandlebars', {
      sessionId: sessionId,
      ...filters,
    })
  }

  static async fetchAverageHandlebar({
    sessionId = undefined,
    bikeHoodsType = BikeHoodsType.DROPBAR,
  }: {
    sessionId?: string
    bikeHoodsType?: BikeHoodsType
  } = {}): Promise<handlebarType> {
    let filters = {}

    switch (bikeHoodsType) {
      case BikeHoodsType.DROPBAR:
        filters = { FreeTextSearch: 'PRO LT', Width: 420 }
        break
      case BikeHoodsType.FLATBAR:
        filters = { FreeTextSearch: 'PRO Koryak Flat', Width: 420 }
        break
      case BikeHoodsType.TRIBAR:
        filters = { FreeTextSearch: 'PRO Missile EVO', Width: 400 }
        break
      default:
        filters = { FreeTextSearch: 'PRO LT', Width: 420 }
    }

    const { data } = await this.fetchHandlebars({
      sessionId: sessionId,
      filters: filters,
    })
    return data.Handlebars[0] ?? undefined
  }

  static getWidthIcon(bikeHoodsType: BikeHoodsType) {
    switch (bikeHoodsType) {
      case BikeHoodsType.DROPBAR:
        return '/icons/filters/handlebar__road--width.svg'
      case BikeHoodsType.FLATBAR:
        return '/icons/filters/handlebar__mtb--width.svg'
      case BikeHoodsType.TRIBAR:
        return '/icons/filters/handlebar__tri--width.svg'
      default:
        return '/icons/filters/handlebar__road--width.svg'
    }
  }

  static getSweepIcon(bikeHoodsType: BikeHoodsType) {
    switch (bikeHoodsType) {
      case BikeHoodsType.DROPBAR:
        return '/icons/filters/handlebar__road--sweep.svg'
      case BikeHoodsType.FLATBAR:
        return '/icons/filters/handlebar__mtb--sweep.svg'
      default:
        return '/icons/filters/handlebar__road--sweep.svg'
    }
  }
}
